import { Route } from '@angular/router';
import { AuthGuard } from 'app/core/auth/guards/auth.guard';
import { NoAuthGuard } from 'app/core/auth/guards/noAuth.guard';
import { LayoutComponent } from 'app/layout/layout.component';
import { InitialDataResolver } from 'app/app.resolvers';
import { UserRoleGuard } from './core/auth/guards/userRole.guard';

// @formatter:off
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
export const appRoutes: Route[] = [

    // Redirect empty path to '/dashboard'
    { path: '', pathMatch: 'full', redirectTo: 'dashboard' },

    // Redirect signed in user to the '/dashboard'
    //
    // After the user signs in, the sign in page will redirect the user to the 'signed-in-redirect'
    // path. Below is another redirection for that path to redirect the user to the desired
    // location. This is a small convenience to keep all main routes together here on this file.
    { path: 'signed-in-redirect', pathMatch: 'full', redirectTo: 'dashboard' },
    { path: '404', loadChildren: () => import('app/pages/error-404/error-404.module').then(m => m.Error404Module) },
    // Auth routes for guests
    {
        path: '',
        canActivate: [NoAuthGuard],
        canActivateChild: [NoAuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            { path: 'confirmation-required', loadChildren: () => import('app/pages/auth/confirmation-required/confirmation-required.module').then(m => m.AuthConfirmationRequiredModule) },
            { path: 'forgot-password', loadChildren: () => import('app/pages/auth/forgot-password/forgot-password.module').then(m => m.AuthForgotPasswordModule) },
            { path: 'reset-password', loadChildren: () => import('app/pages/auth/reset-password/reset-password.module').then(m => m.AuthResetPasswordModule) },
            { path: 'sign-in', loadChildren: () => import('app/pages/auth/sign-in/sign-in.module').then(m => m.AuthSignInModule) },
            { path: 'sign-up', loadChildren: () => import('app/pages/auth/sign-up/sign-up.module').then(m => m.AuthSignUpModule) },
            { path: 'verify-otp', loadChildren: () => import('app/pages/auth/verify-otp/verify-otp.module').then(m => m.VerifyOtpModule) },
            { path: 'reset-password-wp', loadChildren: () => import('app/pages/auth/reset-password-wp/reset-password-wp.module').then(m => m.AuthResetPasswordModuleWp) },
        ]
    },
    {
        path: 'api',
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        loadChildren: () => import('app/pages/static-pages/static-pages.module').then(m => m.StaticPagesModule)
    },
    // Auth routes for authenticated users
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            { path: 'sign-out', loadChildren: () => import('app/pages/auth/sign-out/sign-out.module').then(m => m.AuthSignOutModule) },
            { path: 'unlock-session', loadChildren: () => import('app/pages/auth/unlock-session/unlock-session.module').then(m => m.AuthUnlockSessionModule) }
        ]
    },

    // Landing routes
    {
        path: '',
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            { path: 'home', loadChildren: () => import('app/pages/landing/home/home.module').then(m => m.LandingHomeModule) },
        ]
    },

    // Admin routes
    // {
    //     path       : '',
    //     canActivate: [AuthGuard],
    //     canActivateChild: [AuthGuard],
    //     component  : LayoutComponent,
    //     resolve    : {
    //         initialData: InitialDataResolver,
    //     },
    //     children   : [
    //         {path: 'dashboard', loadChildren: () => import('app/modules/admin/dashboard/dashboard.module').then(m => m.DashboardModule)},
    //         // {path: 'list-applicants', loadChildren: () => import('app/modules/applicants/applicants.module').then(m => m.ApplicantsModule)},
    //     ]
    // },
    // Admin routes
    // {
    //     path       : 'applicants',
    //     canActivate: [AuthGuard],
    //     canActivateChild: [AuthGuard],
    //     component  : LayoutComponent,
    //     resolve    : {
    //         initialData: InitialDataResolver,
    //     },
    //     children   : [
    //         {path: 'list-applicants', loadChildren: () => import('app/modules/applicants/applicants.module').then(m => m.ApplicantsModule)},
    //     ]
    // },

    // Admin routes
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        resolve: {
            initialData: InitialDataResolver,
        },
        children: [
            // Dashboards
            {
                path: 'dashboard', loadChildren: () => import('app/pages/admin/dashboard/dashboard.module').then(m => m.DashboardModule)
            },

            //Settings
            { path: 'settings', loadChildren: () => import('app/pages/settings/settings.module').then(m => m.SettingsModule) },

            // Search
            { path: 'search', loadChildren: () => import('app/pages/search/search.module').then(m => m.SearchModule) },


            // Applicants
            {
                path: 'applicants', children: [
                    { path: '', loadChildren: () => import('app/pages/applicants/applicants.module').then(m => m.ApplicantsModule) },
                ],
                canActivate: [UserRoleGuard],
                canActivateChild: [UserRoleGuard],
            },

            // Customers
            {
                path: 'customers', canActivate: [UserRoleGuard],
                canActivateChild: [UserRoleGuard], children: [
                    { path: '', loadChildren: () => import('app/pages/customers/customers.module').then(m => m.CustomersModule) },
                ]
            },

            // Projects
            {
                path: 'projects',
                canActivate: [UserRoleGuard],
                canActivateChild: [UserRoleGuard], children: [
                    { path: '', loadChildren: () => import('app/pages/projects/projects.module').then(m => m.ProjectsModule) },
                ]
            },

            // Offers
            {
                path: 'offers',
                canActivate: [UserRoleGuard],
                canActivateChild: [UserRoleGuard], children: [
                    { path: '', loadChildren: () => import('app/pages/offers/offers.module').then(m => m.OffersModule) },
                ]
            },
            // Working Partner
            {
                path: 'wp',
                canActivate: [UserRoleGuard],
                canActivateChild: [UserRoleGuard],
                children: [
                    { path: '', loadChildren: () => import('app/pages/working-partners/working-partners.module').then(m => m.WorkingPartnersModule) },
                ]
            },
            // tasks
            {
                path: 'tasks',
                canActivate: [UserRoleGuard],
                canActivateChild: [UserRoleGuard],
                children: [
                    { path: '', loadChildren: () => import('app/tasks/tasks.module').then(m => m.TasksModule) },
                ]
            },
            {
                path: 'timesheets',

                children: [
                    { path: '', loadChildren: () => import('app/pages/timesheets/timesheets.module').then(m => m.TimesheetsModule) },
                ]
            },
            // Acitvity Log
            {
                path: 'activity-log',
                // canActivate: [UserRoleGuard],
                canActivateChild: [UserRoleGuard], children: [
                    { path: '', loadChildren: () => import('app/pages/activity-log/activity-log.module').then(m => m.ActivityLogModule) },
                ]
            },

        ]
    },

    { path: 'api', loadChildren: () => import('app/pages/static-pages/static-pages.module').then(m => m.StaticPagesModule) },

    { path: '**', redirectTo: '/404' }
];
